export default {
  namespaced: true,
  state: {
    siteSelect: [],
  },
  getters: {
    getSiteSelect(state) {
      return state.siteSelect
    },
  },
  mutations: {
    SET_SITE_SELECT(state, value) {
      state.siteSelect = value
    },
  },
  actions: {
    setSiteSelect({ commit }, value) {
      localStorage.setItem("internal-site-select", JSON.stringify(value))
      commit("SET_SITE_SELECT", value)
    },
  },
}
